import {
  ImagesMainBannerFebruaryBottleOfTheMonthWebp,
  ImagesMainBannerFebruaryMacallanWebp,
} from '@/assets/images_main-banner_february.assets';
import { ImagesMainBannerMarchArdbegWebp } from '@/assets/images_main-banner_march.assets';
import { ImagesMainBannerHeaderBannerGiveawayAprilWebp } from '@/assets/images_main-banner_header-banner.assets';
import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexEnum } from '@/types/translations/IndexEnum';
import Image from 'next/image';
export function BottleOfTheMonth() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-between tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-basis-full tw-items-center tw-justify-between max-xl:tw-basis-2/4 max-nine:tw-basis-full max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-flex tw-flex-col tw-gap-[20px] tw-pl-[80px] tw-pt-[20px] max-nine:tw-pl-0 max-nine:tw-text-center max-md:tw-w-full">
          <h2 className="tw-m-0 tw-mx-auto tw-flex tw-w-fit tw-flex-col tw-border-4 tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border-solid tw-border-white tw-pb-4 tw-text-center tw-font-prata tw-text-5xl tw-text-white max-xl:tw-text-4xl max-nine:tw-relative max-nine:tw-max-w-[300px] max-nine:tw-border-b-0 max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-md:tw-w-full">
            {translate(IndexEnum['bottles_of_the_month.bottles_of_the_month'])}
            <hr
              className="tw-hidden max-nine:tw-absolute max-nine:tw-bottom-0 max-nine:tw-m-0 max-nine:tw-block max-nine:tw-h-1 max-nine:tw-w-full max-nine:tw-rounded-full max-nine:tw-border-t-0 max-nine:tw-border-none max-nine:tw-bg-custom-gold max-nine:tw-p-0 max-nine:tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div className="max-nine:tw-flex max-nine:tw-flex-col max-nine:tw-items-center max-md:tw-w-full">
            <p className="tw-text-white max-nine:tw-m-auto max-nine:tw-mb-6 max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm max-md:tw-w-full nine:tw-max-w-[500px]">
              {translate(IndexEnum['bottles_of_the_month.bottles_of_the_month_subtitle'])}
            </p>
            <PrimaryButtonLink
              href="/collections/top-10-whiskies-of-march-2025-en"
              white={true}
              className="tw-px-12 tw-text-main max-nine:tw-mx-auto max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['bottles_of_the_month.explore_our_collection'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerFebruaryBottleOfTheMonthWebp}
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}
export function Macallan() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-start tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-basis-[100%] tw-items-center tw-justify-between max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-ml-[20%] tw-flex tw-flex-col max-nine:tw-ml-0 max-nine:tw-items-center max-nine:tw-text-center max-md:tw-w-full">
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-font-prata tw-text-4xl tw-leading-[1.3] tw-text-white tw-opacity-90 max-xl:tw-text-4xl max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-md:tw-w-full">
            {translate(IndexEnum['macallan.h2'])}: <br></br>
            {translate(IndexEnum['macallan.h2_2'])}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div className="max-md:tw-w-full">
            <p className="tw-mb-6 tw-pt-4 tw-text-white tw-opacity-90 max-nine:tw-m-auto max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm nine:tw-max-w-[500px]">
              {translate(IndexEnum['macallan.p'])}
            </p>
            <div className="max-nine:tw-flex max-nine:tw-flex-col max-nine:tw-items-center max-nine:tw-gap-4">
              <PrimaryButtonLink
                href={`/brands/Macallan`}
                white={true}
                className="tw-mr-4 tw-px-12 tw-text-main max-nine:tw-mx-auto max-nine:tw-mr-0 max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
              >
                {translate(IndexEnum['discover_products'])}
              </PrimaryButtonLink>
              <PrimaryButtonLink
                href={`/blog`}
                white={false}
                className="tw-px-12 tw-text-white max-nine:tw-mx-auto max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
              >
                {translate(IndexEnum['read_our_blog'])}
              </PrimaryButtonLink>
            </div>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerFebruaryMacallanWebp}
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}

export function Ardbeg() {
  const { translate } = useTypedTranslation<IndexEnum>('index');
  return (
    <div className="col-12 tw-relative tw-flex tw-h-[390px] tw-items-center tw-justify-start tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-end max-nine:tw-justify-center max-nine:tw-px-4 max-nine:tw-backdrop-blur-sm max-nine:tw-backdrop-brightness-50">
        <div className="tw-mr-[10%] tw-flex tw-flex-col max-nine:tw-mr-0 max-nine:tw-items-center max-nine:tw-text-center">
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-text-right tw-font-prata tw-text-4xl tw-leading-[1.3] tw-text-black tw-opacity-90 max-xl:tw-text-4xl max-nine:tw-max-w-[300px] max-nine:tw-text-center max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-white">
            {translate(IndexEnum['ardbeg.title'])}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          <div>
            <p className="tw-mb-6 tw-max-w-[500px] tw-pt-4 tw-text-right tw-text-black tw-opacity-90 max-nine:tw-m-auto max-nine:tw-max-w-[280px] max-nine:tw-pb-2 max-nine:tw-text-center max-nine:tw-text-sm max-nine:tw-text-white">
              {translate(IndexEnum['ardbeg.text'])}
            </p>
            <PrimaryButtonLink
              href={`/collections/top-10-ardbeg-whiskies-you-need-to-try`}
              white={false}
              className="tw-float-right tw-px-12 tw-text-white max-nine:tw-float-none max-nine:tw-flex max-nine:tw-items-center max-nine:tw-justify-center max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['bottles_of_the_month.explore_our_collection'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      <Image
        src={ImagesMainBannerMarchArdbegWebp}
        priority={true}
        alt="main banner background image"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover"
      />
    </div>
  );
}

export function GiveAway() {
  const { translate } = useTypedTranslation<IndexEnum>('index');

  return (
    <div className="tw-flex tw-h-[390px] tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[30px] max-nine:tw-h-[320px] max-nine:tw-rounded-none">
      <div className="tw-flex tw-h-full tw-basis-[100%] tw-items-center tw-justify-end max-nine:tw-justify-center max-nine:tw-px-4 max-md:tw-backdrop-brightness-50">
        <div className="tw-mr-[9.5%] tw-flex tw-flex-col tw-items-center tw-justify-center max-nine:tw-mr-0 max-nine:tw-text-center max-md:tw-w-full">
          {/* Title Section */}
          <h2 className="tw-relative tw-m-0 tw-flex tw-max-w-[500px] tw-flex-col tw-pb-4 tw-text-center tw-font-prata tw-text-5xl tw-leading-[1.3] tw-text-black tw-opacity-90 max-nine:tw-max-w-[300px] max-nine:tw-text-2xl max-nine:tw-leading-[1.2] max-nine:tw-text-white max-md:tw-w-full">
            {translate(IndexEnum['give_away_header'])}
            <hr
              className="tw-absolute tw-bottom-0 tw-m-0 tw-h-1 tw-w-[100%] tw-rounded-full tw-border-t-0 tw-border-none tw-bg-custom-gold tw-p-0 tw-opacity-100"
              aria-hidden="true"
            />
          </h2>
          {/* Text Content */}
          <div className="max-md:tw-w-full">
            <p className="tw-text-1xl tw-align-center tw-m-auto tw-mb-3 tw-max-w-[500px] tw-pt-4 tw-text-center tw-text-black tw-opacity-90 max-nine:tw-mb-0 max-nine:tw-max-w-[280px] max-nine:tw-pb-2 max-nine:tw-text-sm max-nine:tw-text-white">
              {translate(IndexEnum['give_away_text1'])}.
            </p>
            <p className={`tw-mb-7 tw-text-black max-nine:tw-text-sm max-nine:tw-text-white`}>
              {translate(IndexEnum['give_away_text2'])}
            </p>
            {/* CTA Button */}
            <PrimaryButtonLink
              href={`/auth/sign-up`}
              className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-px-24 tw-text-center tw-text-white max-nine:tw-max-w-44 max-nine:tw-px-6 max-nine:tw-text-sm"
            >
              {translate(IndexEnum['header.sign_up'])}
            </PrimaryButtonLink>
          </div>
        </div>
      </div>
      {/* Background Image */}
      <Image
        src={ImagesMainBannerHeaderBannerGiveawayAprilWebp}
        width={1280}
        height={384}
        priority={true}
        loading="eager"
        fetchPriority="high"
        alt="main banner background image"
        className="tw-absolute tw-inset-0 -tw-z-10 tw-h-full tw-w-full tw-rounded-[30px] tw-object-cover max-nine:tw-rounded-none max-md:tw-object-left"
        sizes="100vw"
        quality={90}
      />
    </div>
  );
}
